var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInformationFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bounding_box",
    "data-name": "Bounding box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 11.99781 2 C 6.4749799999999995 2 1.9978099999999994 6.47711 1.9978099999999994 12 C 1.9978099999999994 17.52283 6.4749799999999995 22 11.99781 22 C 17.520699999999998 22 21.99781 17.52283 21.99781 12 C 21.99781 6.47711 17.5207 2 11.99781 2 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 13.25 8 C 13.25 8.725 12.722 9.25 12.008 9.25 C 11.265 9.25 10.75 8.725 10.75 7.986 C 10.75 7.276 11.279 6.75 12.008 6.75 C 12.722 6.75 13.25 7.276 13.25 8 Z M 11 11 L 13 11 L 13 17 L 11 17 Z",
    style: {
      fill: "#FFFFFF"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationFilled);
export default __webpack_public_path__ + "static/media/Information-filled.31d83384fb05695d05ed8689cd70ca13.svg";
export { ForwardRef as ReactComponent };